import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


// const endpoint = environment.apiEmailFromUrl;
const endpoint = environment.apiBaseUrl + '/asistente/empresas';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  public cargarDatosEmpresa(formData): Observable<any> {
    //return this.http.get<any>(`${endpoint}/${asistente}/${idNodo}/${tipo}/${dato}`).pipe(map(this.extractData));
    return this.http.post<any>(endpoint, formData, httpOptions).pipe(map(this.extractData));
  }

}
